import React from 'react';

const Monitoring = () => {
  return (
    <iframe title="transport-monitoring" style={{ border: 'none' }} width="100%" height="100%" />
  );
};

export default Monitoring;
